// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 2H2V22H22V2ZM12 8.5L16.25 14H7.75L12 8.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chevron-up-rectangle-filled')
export default class ChevronUpRectangleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chevron-up-rectangle-filled',
    }
  }
}
